module.exports = __webpack_public_path__ + "static/fonts/DINMedium.39d8205e.ttf";